<template>
  <page
    :custom-style="{
      display: 'flex',
      'flex-direction': 'column',
      height: '100vh',
      backgroundColor: '#F5F5F5'
    }"
  >
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      class="navbar"
      :safe-top-distance="statusBarHeight"
      left-arrow
      left-arrow-color="#fff"
      background="transparent"
      @click-left="goBack"
    />
    <div class="logo" :style="{ height: logoHeight }">
      <img :src="logoUrl" @click.stop.prevent />
    </div>
    <div v-if="reqlist.length && inited" class="new-good-list">
      <div class="title">我提报过的新品</div>
      <ul class="history-list">
        <li
          v-for="item in reqlist"
          :key="item.id"
          @click="gotoDetail({ reqId: item.demandId })"
        >
          <div class="h-title">{{ item.name }}</div>
          <div
            class="status"
            :class="{
              green: item.status == 2 || item.status == 3,
              red: item.status == 6
            }"
          >
            {{ item.statusDesc }}
          </div>
          <IconFont name="mc-icon-arrowright" size="12px" color="#c7c7c7" />
        </li>
      </ul>
    </div>
    <div v-if="!reqlist.length && inited" class="new-good-list">
      <p class="desc">您还没提报过新品</p>
      <div
        class="sub-btn report-new2"
        :class="themeBgColorClass"
        @click="goFormAdd"
      >
        我要提报新品
      </div>
    </div>
    <div
      v-if="reqlist.length"
      class="sub-btn report-new"
      :class="themeBgColorClass"
      @click="goFormAdd"
    >
      我要提报新品
    </div>
  </page>
</template>

<script>
import logoUrl from '@/images/new_good_req/title_bg.png'
import { API } from '@/api'
import { dateTimeFormatter } from '@/utils/utils'
import themeMixin from '@/common/mixins/theme'
export default {
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {
      browerInfo: window.matrix,
      inited: false,
      headerOpacity: 0,
      loading: true,
      isLastPage: false,
      reqlist: [],
      logoUrl,
      safePaddingTop: false
    }
  },
  computed: {
    logoHeight() {
      if (this.browerInfo.isMallApp) {
        return 210 + this.statusBarHeight + 'px'
      } else {
        return '210px'
      }
    }
  },
  methods: {
    goBack() {
      this.$back()
    },
    init() {
      this.curPage = 1
      this.pageSize = 100
      this.fetchList()
    },
    goFormAdd() {
      this.$track(this.$trackMap.newGoodReq.listAdd)
      this.$router.push({
        path: '/new-good-req/add'
      })
    },
    gotoDetail(item) {
      this.$router.push({
        path: '/new-good-req/detail',
        query: {
          reqId: item.reqId
        }
      })
    },
    async fetchList() {
      this.loading = true
      // 第一次展示loading
      if (!this.inited) {
        this.$Loading()
      }
      try {
        const resData = await API.newReqGood.getNewGoodReqList({
          page: this.curPage,
          count: this.pageSize
        })
        const reqList = (resData.list || []).map(item => {
          return {
            name: item.commodity_name,
            dateStr: dateTimeFormatter(
              new Date(item.c_t * 1000),
              'YYYY.MM.DD HH:mm:ss'
            ),
            demandId: item.demand_id,
            status: item.status,
            statusDesc: item.status_desc
          }
        })
        this.loading = false
        if (!this.inited) {
          this.$Loading.hide()
          this.inited = true
        }
        this.reqlist = this.reqlist.concat(reqList)
        this.curPage++
        this.isLastPage = true // 100条封顶
      } catch (e) {
        if (!this.inited) {
          this.$Loading.hide()
          this.inited = true
        }
        this.loading = false
        this.$catch(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}
.logo {
  width: 100%;

  flex: none;
  img {
    width: 100%;
    height: 100%;
  }
}
.new-good-list {
  height: 0;
  overflow: scroll;

  background-color: #fff;

  flex: auto;
  .title {
    padding: 0.29rem 0 0.18rem;

    background-color: #f5f5f5;

    font-size: 0.3rem;
    text-align: center;
    color: #888;
  }

  .desc {
    margin: 0.86rem 0 0.4rem;

    font-size: 0.48rem;
    text-align: center;
    color: #888;
  }

  .report-new2 {
    width: 90%;
    height: 0.94rem;
    margin: 0 auto;

    border-radius: 0.1rem;

    @include flex-row-center;
  }
}

.history-list {
  background-color: #fff;
  li {
    display: flex;

    height: 1.19rem;
    margin: 0 0.36rem;

    border-bottom: 1px solid #e8e8e8;

    justify-content: flex-end;
    align-items: center;

    .h-title {
      margin-right: 0.2rem;
      overflow: hidden;

      flex: 1;

      font-size: 0.34rem;
      white-space: nowrap;
      color: #000;

      text-overflow: ellipsis;
    }

    .date {
      margin-right: 0.4rem;

      font-size: 0.32rem;
      color: #888;
    }

    .arrow {
      margin-top: 2px;

      color: #c7c7cc;
    }

    .status {
      margin-right: 0.16rem;

      font-size: 0.32rem;

      &.green {
        color: #0daf52;
      }

      &.red {
        color: #ff6f14;
      }
    }
  }
}

.sub-btn {
  background-color: #0daf52;

  font-size: 0.34rem;
  color: #fff;
}
.report-new {
  height: 1.08rem;

  @include flex-row-center;
}
</style>
